import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';
import axios from 'axios';

export default async function fetchBusinessInfo(businessId) {
    const apiPath = `business/${businessId}/get-business-info`;

    const request = {
        url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
        // url: `http://localhost:3001/${apiPath}`,
        host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
        path: apiPath,
        method: 'GET',
        region: Config.AWS_REGION,
        service: 'execute-api',
    };
    const signedRequest = await createSignedRequest(request);

    const response = await axios(signedRequest);

    return response.data;
};
